export const w6 = {
    'images': [],
    'mainFeatures': [
        'Premium Nature Rubber with Nano Graphite Coating',
        'Patented Multi-Functional Base Design',
        'Waterproof design to prevent structural freezing',
    ],
    'material': [
        'Rubber: Nano Graphite Coating with Nature Rubber (Winter Rubber formula)',
        'Steel: SK7, Electrostatic Powder Coating',
        'Rivet: Stainless Steel',
        'Spoiler: Latex Rubber',
    ],
    'featureIcons': ["11", "02", "03", "07"],
    'otherFeatures': ["01", "02"],
    'specification': [
        { "inch": "13", "mm": "330", "width": "6", "thickness": "0.8" },
        { "inch": "14", "mm": "350", "width": "6", "thickness": "0.8" },
        { "inch": "15", "mm": "375", "width": "6", "thickness": "0.8" },
        { "inch": "16", "mm": "400", "width": "6", "thickness": "0.8" },
        { "inch": "17", "mm": "430", "width": "6", "thickness": "0.8" },
        { "inch": "18", "mm": "450", "width": "6", "thickness": "0.8" },
        { "inch": "19", "mm": "480", "width": "6", "thickness": "0.8" },
        { "inch": "20", "mm": "500", "width": "6", "thickness": "0.8" },
        { "inch": "21", "mm": "525", "width": "6", "thickness": "0.8" },
        { "inch": "22", "mm": "550", "width": "6", "thickness": "0.8" },
        { "inch": "24", "mm": "600", "width": "6", "thickness": "0.9" },
        { "inch": "26", "mm": "650", "width": "6", "thickness": "0.9" },
        { "inch": "28", "mm": "700", "width": "6", "thickness": "0.9" }
    ],
    'adapters': ['b1', 'b6', 'bl-2a', 'cl+cl-r', "m3", 'm4', 'm5', 'ml', 'ph-3', 'pl', 'pt-3', 'pt6', 'pt-r', 'tl-2', 'tl4a', 'tlc']
}
